// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1MYPb","content":"Consent_content__2TBx3","footer":"Consent_footer__3sB3L"};